import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'

interface GeneralIntroScreenProps {
	onNext: () => void
	tipoSeguro?: string
}

export function GeneralIntroScreen({
	onNext,
	tipoSeguro,
}: GeneralIntroScreenProps) {
	const titulo = tipoSeguro ? `Cotización de ${tipoSeguro}` : 'Cotización de Seguro'

	return (
		<div className="flex h-full w-full flex-col">
			<div className="flex flex-1 flex-col items-center justify-center gap-6">
				<div className="flex size-20 items-center justify-center rounded-full bg-blue-100">
					<Icon name="document-validation" className="size-10 text-blue-600" />
				</div>

				<div className="flex flex-col items-center gap-3">
					<h1 className="font-parkinsans text-center text-2xl font-medium text-blue-800 md:text-3xl">
						{titulo}
					</h1>
					<p className="max-w-md text-center text-neutral-600">
						Completá el formulario con tus datos y contanos qué tipo de
						cobertura necesitás. Nuestro equipo se pondrá en contacto con vos
						para asesorarte.
					</p>
				</div>

				<div className="flex flex-col gap-3 rounded-xl bg-neutral-50 p-4">
					<div className="flex items-center gap-3">
						<div className="flex size-8 items-center justify-center rounded-full bg-blue-100">
							<span className="text-sm font-medium text-blue-600">1</span>
						</div>
						<span className="text-sm text-neutral-700">
							Completá tus datos de contacto
						</span>
					</div>
					<div className="flex items-center gap-3">
						<div className="flex size-8 items-center justify-center rounded-full bg-blue-100">
							<span className="text-sm font-medium text-blue-600">2</span>
						</div>
						<span className="text-sm text-neutral-700">
							Describí qué cobertura necesitás
						</span>
					</div>
					<div className="flex items-center gap-3">
						<div className="flex size-8 items-center justify-center rounded-full bg-blue-100">
							<span className="text-sm font-medium text-blue-600">3</span>
						</div>
						<span className="text-sm text-neutral-700">
							Te contactamos con una propuesta personalizada
						</span>
					</div>
				</div>
			</div>

			<div className="flex w-full shrink-0 flex-col items-center justify-center bg-white pt-4 md:bg-transparent md:pt-8">
				<Button
					variant="secondary"
					appearance="solid"
					size="l"
					onClick={onNext}
					className="w-full md:w-auto"
				>
					Comenzar
					<Icon name="arrow-right" className="size-3.5" />
				</Button>
			</div>
		</div>
	)
}
